import React from 'react'
import PropTypes from 'prop-types'
import { Heading, Container } from '@scentregroup/ui'
import { Link } from 'react-router-dom'
import ContentGroup from '../../../../components/content-group'
import ProductCard from '../../products-gallery/product-card'
import productImpressions from '../../../../helpers/analytics-utils/product-impressions'
import style from './index.module.scss'

const MoreProducts = ({ products, retailerName, retailerCode }) => {
  const list = `More Products From ${retailerName}`
  productImpressions(products, list)
  return (
    <ContentGroup
      angleOrigin={'top-right'}
      color={'Grey'}
      className={style.moreProductsWrap}
    >
      <Container centred type="large">
        <div className={style.moreProducts}>
          <Heading type="small" className={style.retailerTitle}>
            More Products from {retailerName}
          </Heading>
          <div className={style.productCards}>
            {products.map((product, index) => (
              <ProductCard
                key={index}
                src={product.images[0]}
                retailer={product.retailer.name}
                productName={product.name}
                price={product.price}
                salePrice={product.isDiscounted ? product.salePrice : undefined}
                link={`/products/${product.retailer.retailerCode}/${product.nameSlug}/${product.objectId}`}
                className={style.productCard}
                id={product.objectId}
                list={list}
                primaryCategory={product.primaryCategory}
                brand={product.brand}
                position={index + 1}
                retailerCode={product.retailer.retailerCode}
              />
            ))}
          </div>
          <Link
            to={`/products/retailer/${retailerCode}`}
            className={style.linkItem}
          >
            See More From {retailerName}
          </Link>
        </div>
      </Container>
    </ContentGroup>
  )
}

MoreProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  retailerName: PropTypes.string.isRequired,
  retailerCode: PropTypes.string.isRequired,
}

export default MoreProducts
